// extracted by mini-css-extract-plugin
module.exports = {"gameInfo":"gameInfo_gameInfo__Qzeq1","upsetAlert":"gameInfo_upsetAlert__v29K1","infoLeft":"gameInfo_infoLeft__Dc2H1","infoRight":"gameInfo_infoRight__zDrPg"};